"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactPasswordStrengthBar = _interopRequireDefault(require("react-password-strength-bar"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PasswordContainerThreeBars = _styledComponents["default"].div.withConfig({
  displayName: "password_strength_bar__PasswordContainerThreeBars"
})(["> div > div > div:nth-last-child(-n + 2){display:none;}> div > div > div:nth-child(even){width:2px !important;}"]);
var PasswordStrengthBar = function PasswordStrengthBar(props) {
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    password = _useState2[0],
    setPassword = _useState2[1];
  (0, _react.useEffect)(function () {
    // @ts-expect-error - TS2339 - Property 'selector' does not exist on type 'Props'.
    if (typeof props.selector === 'string') {
      // @ts-expect-error - TS2339 - Property 'selector' does not exist on type 'Props'.
      var passwordInput = document.querySelector(props.selector);
      if (!passwordInput) {
        return;
      }
      passwordInput.addEventListener('keyup', function (e) {
        var target = e.target;
        setPassword(target.value);
      });
    }
  });
  return /*#__PURE__*/_react["default"].createElement(PasswordContainerThreeBars, null, /*#__PURE__*/_react["default"].createElement(_reactPasswordStrengthBar["default"], (0, _extends2["default"])({
    scoreWords: [],
    barColors: ['#ddd', '#d8372a', '#f2cd00', '#047957', '#047957'],
    shortScoreWord: '',
    password: password
  }, props)));
};
var _default = exports["default"] = PasswordStrengthBar;